<template>
<div v-if='project' >
  <div class="Modal__header">
    <h3>Supprimer le parcours ?</h3>
  </div>

  <div class="Modal__body"  >
    <p>Vous êtes sur le point de supprimer définitivement le parcours {{ project.name }} {{ project.contact_lastname }}</p>
    <p>Toutes les données relatives à ce parcours seront également supprimées.</p>
  </div>

  <div class="Modal__footer">
    <button class="Modal__buton-ok" @click="cancel()">
      Annuler
    </button>
    <button class="Modal__buton-danger" @click="confirm()">
      Supprimer
    </button>
  </div>
</div>
</template>

<script>
  import { deleteProject } from '../../vuex/actions/projectActions'

  export default{
    props: ['project'],
    vuex: {
      actions: {
        deleteProject
      }
    },
    data () {
      return {}
    },
    methods: {
      cancel () {
        this.$dispatch('closeModal')
      },
      confirm () {
        this.deleteProject(this.project)
        this.$dispatch('closeModal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteProject.vue?0526cd84